import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild, ElementRef, Inject } from '@angular/core';
import { REST_SERVER_DB_SHARD_ID, REST_SERVER_HOST } from '@schoolbelle/api/tokens';

@Component({
  selector: 'app-profile-img',
  templateUrl: './profile-img.component.html',
  styleUrls: ['./profile-img.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class ProfileImgComponent implements OnInit {
  @ViewChild('img') imgElRef:ElementRef;
  @Input() defaultSrc:string = 'assets/images/default-profile.jpg';
  
  private _src:string|undefined;
  @Input() set src (v:string|undefined) {
    this._src = v;
  };
  get url () {
    if (this._src && this._src.startsWith('file:///')) return undefined;
    // https://v4.schoolbell-e.com/api/file/4452736/original.png
    let v4Match = this._src && this._src.match(/\/api\/file\/([\d]+)\//);
    if (v4Match) return `https://v5.schoolbell-e.com/api/file/image/${this.db_id}:${v4Match[1]}?size=profile`;

    return this._src;
  }

  @Input() set width (width:number|string|undefined) {
    const img = (<HTMLImageElement>this.imgElRef.nativeElement);
    img.style.width = null;
    img.width = null;

    if (typeof width === 'number') img.width = width;
    else if (typeof width === 'string' && width.endsWith('%')) img.style.width = width;
    else if (typeof width === 'string' && width.endsWith('px')) img.style.width = width;
  }
  @Input() set height (height:number|string|undefined) {
    const img = (<HTMLImageElement>this.imgElRef.nativeElement);
    img.style.height = null;
    img.height = null;

    if (typeof height === 'number') img.height = height;
    else if (typeof height === 'string' && height.endsWith('%')) img.style.height = height;

  }
  constructor (
    @Inject(REST_SERVER_DB_SHARD_ID) private db_id:string,    
  ) {

  }

  ngOnInit() {
  }
  ngOnDestroy () {
  }
}
